import React from "react";
import Department from "./Department";
import JobListing from "./JobListing";

interface Props {
  jobListings: readonly JobListing[];
  department: Department;
  onClickViewAll?: () => void;
  displayHeader?: boolean;
}

export default function DepartmentJobs({
  jobListings,
  department,
  onClickViewAll,
  displayHeader = true,
}: Props) {
  return (
    <div id="jobListings" className="careers-positions-job-listing block">
      {displayHeader && (
        <>
          <button
            id="viewAllJobs"
            type="button"
            className="btn-outline-reverse careers-positions__return-departments return-departments"
            onClick={onClickViewAll}
          >
            <i className="icon-left-open" /> View All Jobs
          </button>

          <a
            href={`/careers/department/${department.id}/${department.seoUrlKey}/`}
            className="btn-outline-reverse careers-positions__department-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn About Department <i className="icon-right-open" />
          </a>
          <h2 className="careers-positions__right-title">
            {department.name} Jobs
          </h2>
        </>
      )}

      {jobListings.map((job) => (
        <a
          key={`job-id-${job.id}`}
          href={`/careers/department/${department.seoUrlKey}/${job.id}/${job.jobNumber}/`}
          className={`job-listing careers-positions-block ${job.stateAbbreviation}-job-listing`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="job-listing"
        >
          <div className="careers-positions-block-content">
            <h3 className="careers-positions__block-title">{job.title}</h3>
            <div className="careers-positions__block-openings">
              {job.city}, {job.stateAbbreviation}
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}
